import { useContext } from "react";
import { OrdersModalContext } from "./OrdersModalProvider";

export const useOrdersModal = () => useContext(OrdersModalContext);
